import React, { useState ,useEffect} from 'react'
import moment from 'moment'
import CommonTablePageWithSortPreserve, { CommonTablePagePropsInterface } from '../../../../components/common/common-table/common-table-page-with-sort-preserve'
import CommonDialog from '../../../../components/common/others/common-dialog'
import { urlKey } from '../../../../services/api/api-urls'
import SweetAlertService from '../../../../services/lib/utils/sweet-alert-service'
import { PurchaseOrderColumnModel } from './purchase-order-column-model'
import PurchaseOrderDialog from './purchase-order-dialog/purchase-order-dialog'
import PurchaseOrderReceivingModal from './purchase-order-receiving-modal'
import PurchaseOrderPutawayModal from './purchase-order-putaway-modal'
import InspectionLogModal from './inspection-log-modal'
import AutoSplitPalletModal from './auto-split-pallet-modal'
import AutoSplitSuccessModal from './auto-split-success-modal'
import MergeToPalletModal from './merge-to-pallet-modal'
import MergeSuccessModal from './merge-success-modal'
import { ApiRequest } from '../../../../services/api/api'
import EmailModal1 from '../../../../components/common/email-dialog'
import {getCookie} from 'react-use-cookie'
import { getRandomKey, toLocalDate } from '../../../../services/lib/utils/helpers'
// import quotationPdfGenerate from '../../static/pdf/PurchaseOrder/PurchaseOrder-pdf'
import PurchaseOrderPdf from '../../../static/pdf/purchaseOrder/purchaseOrder-pdf'
import { Button, DatePicker } from 'antd'
import Swal from 'sweetalert2'
import { CheckCircleOutlined, CheckOutlined, DeleteOutlined, DollarOutlined, EditOutlined, EyeOutlined, FileTextOutlined, MailOutlined } from '@ant-design/icons'
import './purchase-order-page.css'
import { useDocumentTitle } from '../../../../services/title/useDocumentTitle'

interface Email {
  employeeEmail: string
  customerEmail: string
}
// isApprovePage ==> pageType  1: Purchase Order  2 .Purchase Order Approve  3 . payable  4 . receiving
const { RangePicker } = DatePicker
const SIX_MONTHS_AGO = -6;
// 缓存原材料的 productId 信息（全局缓存）
const rawMaterialProductIdCache = new Map<number, number | null>()

export const PurchaseOrderPage = ({ pageType = 1 }: { pageType?: number }) => {
  const [triggerResetData, setTriggerResetData] = useState<any>(false)
  const [isShowSpinner, setIsShowSpinner] = useState(true)
  const [open, setOpen] = useState(false)
  const [orderData, setOrderData] = useState<any>()
  const [pdfData, setPdfData] = useState<any>()
  const [dialogTitle, setDialogTitle] = useState<string>()
  const [isNewOrder, setIsNewOrder] = useState(false)
  const [isView, setisView] = useState(true)
  const [startDate, setStartDate] = useState<any>(moment().add(SIX_MONTHS_AGO, 'months'))
  const [endDate, setEndDate] = useState<any>(moment())
  const [url, setUrl] = useState<string>(
    `PurchaseOrder/GetAllPurchaseOrder?start=${startDate.format('YYYY/MM/DD')}&end=${endDate.format('YYYY/MM/DD')}`
  )

  // 接收弹窗状态
  const [receivingModalVisible, setReceivingModalVisible] = useState(false)
  const [selectedPOData, setSelectedPOData] = useState<any>(null)

  // 上架弹窗状态
  const [putawayModalVisible, setPutawayModalVisible] = useState(false)

  // 自动拆分托盘弹窗状态
  const [autoSplitModalVisible, setAutoSplitModalVisible] = useState(false)
  const [selectedSplitItem, setSelectedSplitItem] = useState<any>(null)

  // 自动拆分成功结果弹窗状态
  const [autoSplitSuccessVisible, setAutoSplitSuccessVisible] = useState(false)
  const [splitPalletData, setSplitPalletData] = useState<any[]>([])
  const [userPalletStacking, setUserPalletStacking] = useState<number>(100)  // 保存用户输入的托盘堆叠数量

  // 合并到托盘弹窗状态
  const [mergeToPalletVisible, setMergeToPalletVisible] = useState(false)
  const [selectedMergeItems, setSelectedMergeItems] = useState<any[]>([])

  // 合并成功弹窗状态
  const [mergeSuccessVisible, setMergeSuccessVisible] = useState(false)
  const [mergePalletResult, setMergePalletResult] = useState<any>(null)
  const [mergeSuccessItems, setMergeSuccessItems] = useState<any[]>([])

  // Putaway Board 刷新触发器
  const [putawayRefreshTrigger, setPutawayRefreshTrigger] = useState<any>(0)

  // Inspection Log Modal 状态
  const [inspectionLogVisible, setInspectionLogVisible] = useState(false)
  const [selectedInspectionPOData, setSelectedInspectionPOData] = useState<any>(null)


  const onDialogClose = (isModified: boolean) => {
    setIsShowSpinner(false)
    setOpen(false)
    setTriggerResetData( Math.random())
  }

  // 验证所有原材料是否都是产品（检查 productId 是否为 null）
  const validateRawMaterialsAreProducts = async (poData: any): Promise<boolean> => {
    if (!poData?.poDetail || poData.poDetail.length === 0) {
      await SweetAlertService.errorMessage('No materials found in this PO')
      return false
    }

    try {
      // 并行检查所有原材料的 productId
      const checks = poData.poDetail.map(async (item: any) => {
        if (!item.rawMaterial?.rawMaterialId) {
          return { valid: false, itemCode: item.rawMaterial?.rawMaterialCode || 'Unknown' }
        }

        try {
          const response = await ApiRequest({
            url: `RawMaterial/GetRawMaterialById?id=${item.rawMaterial.rawMaterialId}`,
            method: 'get',
            isShowSpinner: false
          })

          const rawMaterialData = response?.data?.data
          // 检查 productId 是否为 null
          if (rawMaterialData?.productId === null) {
            return {
              valid: false,
              itemCode: item.rawMaterial?.rawMaterialCode || 'Unknown'
            }
          }

          return { valid: true }
        } catch (error) {
          console.error(`Failed to check raw material ${item.rawMaterial.rawMaterialCode}:`, error)
          return { valid: false, itemCode: item.rawMaterial?.rawMaterialCode || 'Unknown' }
        }
      })

      const results = await Promise.all(checks)

      // 找出所有无效的材料
      const invalidItems = results.filter(r => !r.valid)

      if (invalidItems.length > 0) {
        const itemCodes = invalidItems.map((item: any) => item.itemCode).join(', ')
        await SweetAlertService.errorMessage(`The following materials are not products and cannot be processed: ${itemCodes}`)
        return false
      }

      return true
    } catch (error) {
      console.error('Error validating raw materials:', error)
      await SweetAlertService.errorMessage('Failed to validate materials')
      return false
    }
  }

  // 打开接收弹窗
  const handleOpenReceivingModal = async (poData: any) => {
    // 接收功能对所有材料开放（产品和原材料）
    setSelectedPOData(poData)
    setReceivingModalVisible(true)
  }

  // 关闭接收弹窗
  const handleCloseReceivingModal = () => {
    setReceivingModalVisible(false)
    setSelectedPOData(null)
  }

  // 接收成功后的回调
  const handleReceivingSuccess = () => {
    setTriggerResetData(Math.random())
  }

  // 打开上架弹窗
  const handleOpenPutawayModal = async (poData: any) => {
    // P/W 只对产品有效，需要验证所有原材料都是产品
    const isValid = await validateRawMaterialsAreProducts(poData)
    if (!isValid) {
      return // 验证失败，不打开弹窗
    }

    setSelectedPOData(poData)
    setPutawayModalVisible(true)
  }

  // 关闭上架弹窗
  const handleClosePutawayModal = () => {
    setPutawayModalVisible(false)
    setSelectedPOData(null)
  }

  // 上架成功后的回调
  const handlePutawaySuccess = () => {
    setTriggerResetData(Math.random())
  }

  // 打开 Inspection Log Modal
  const handleOpenInspectionLog = async (poData: any) => {
    try {
      // 获取该 PO 的 Inspection ID
      const response = await ApiRequest({
        url: `UnloadingInspection/GetAllUnloadingInspection?poId=${poData.poId}`,
        method: 'get',
        isShowSpinner: true
      })

      if (response?.data?.data && response.data.data.length > 0) {
        const inspectionData = response.data.data[0]
        if (inspectionData.inspectionId) {
          setSelectedInspectionPOData({ ...poData, inspectionId: inspectionData.inspectionId })
          setInspectionLogVisible(true)
        } else {
          SweetAlertService.errorMessage('No inspection log found for this PO')
        }
      } else {
        SweetAlertService.errorMessage('No inspection log found for this PO')
      }
    } catch (error) {
      console.error('Failed to fetch inspection log:', error)
      SweetAlertService.errorMessage('Failed to fetch inspection log')
    }
  }

  const handleCompletePurchase = async (poData: any) => {
    try {
      // 检查 PO 状态是否为 Receiving (poStatusId=4  Receiving)
      if (poData.poStatusId !== 4) {
        SweetAlertService.errorMessage('Only purchase orders with Receiving status can be completed')
        return
      }

      // 获取 inspectionId
      const inspectionResponse = await ApiRequest({
        url: `UnloadingInspection/GetAllUnloadingInspection?poId=${poData.poId}`,
        method: 'get',
        isShowSpinner: true
      })

      let inspectionId = null
      if (inspectionResponse?.data?.data && inspectionResponse.data.data.length > 0) {
        inspectionId = inspectionResponse.data.data[0].inspectionId
      }

      if (!inspectionId) {
        SweetAlertService.errorMessage('No inspection found for this purchase order')
        return
      }

      // 确认是否完成 Purchase Receiving
      const result = await Swal.fire({
        title: 'Complete Purchase Receiving',
        html: `
          <div style="text-align: left;">
            <p>Are you sure you want to complete the purchase receiving for:</p>
            <div style="background: #f3f4f6; padding: 12px; border-radius: 6px; margin: 10px 0;">
              <div><strong>PO Number:</strong> ${poData.poNo}</div>
              <div><strong>Supplier:</strong> ${poData.supplierName || 'N/A'}</div>
            </div>
            <p style="color: #10b981; font-size: 14px;">✓ All items received (P/W=Rcv)</p>
            <p style="color: #f59e0b; font-size: 14px;">This action will mark the purchase order as completed.</p>
          </div>
        `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Complete',
        cancelButtonText: 'No, Cancel',
        confirmButtonColor: '#10b981',
        cancelButtonColor: '#6b7280'
      })

      if (result.isConfirmed) {
        // 调用 API 完成 Purchase Receiving，使用 inspectionId
        await ApiRequest({
          url: 'UnloadingInspection/Complete?id=' + inspectionId,
          // url: 'PurchaseOrder/ApprovePurchaseOrder?id=' + rowData.poId,
          method: 'put',
          isShowSpinner: true
        })

        SweetAlertService.successMessage('Purchase Receiving completed successfully!')

        // 刷新数据
        setTriggerResetData(getRandomKey())
      }
    } catch (error) {
      console.error('Failed to complete purchase receiving:', error)
      SweetAlertService.errorMessage('Failed to complete purchase receiving')
    }
  }

  // 关闭 Inspection Log Modal
  const handleCloseInspectionLog = () => {
    setInspectionLogVisible(false)
    setSelectedInspectionPOData(null)
  }

  // 打开 Approve Log Modal (用于 Purchase Order Approve 页面)
  const handleOpenApproveLog = async (poData: any) => {
    try {
      // 获取该 PO 的 Inspection ID
      const response = await ApiRequest({
        url: `UnloadingInspection/GetAllUnloadingInspection?poId=${poData.poId}`,
        method: 'get',
        isShowSpinner: true
      })

      if (response?.data?.data && response.data.data.length > 0) {
        const inspectionData = response.data.data[0]
        if (inspectionData.inspectionId) {
          setSelectedInspectionPOData({ ...poData, inspectionId: inspectionData.inspectionId })
          setInspectionLogVisible(true)
        } else {
          SweetAlertService.errorMessage('No inspection log found for this PO')
        }
      } else {
        SweetAlertService.errorMessage('No inspection log found for this PO')
      }
    } catch (error) {
      console.error('Failed to fetch inspection log:', error)
      SweetAlertService.errorMessage('Failed to fetch inspection log')
    }
  }

  // 打开自动拆分托盘弹窗
  const handleOpenAutoSplitModal = (poData: any, itemData: any) => {
    setSelectedPOData(poData)
    setSelectedSplitItem(itemData)
    setAutoSplitModalVisible(true)
  }

  // 关闭自动拆分托盘弹窗
  const handleCloseAutoSplitModal = () => {
    setAutoSplitModalVisible(false)
    setSelectedSplitItem(null)
  }

  // 拆分成功后的回调
  const handleSplitSuccess = (palletData: any[], userPalletStacking: number) => {
    setAutoSplitModalVisible(false)  // 关闭拆分弹窗但不清除itemData
    // 刷新 Putaway Board 数据
    setPutawayRefreshTrigger(Math.random())
    // 等待拆分弹窗关闭后再打开成功弹窗
    setTimeout(() => {
      handleOpenAutoSplitSuccess(palletData, userPalletStacking)
    }, 100)
    // 移除了 setTriggerResetData - 在打开成功弹窗时不需要刷新列表
    // 只在实际保存后才刷新列表（见 AutoSplitSuccessModal 的 onSuccess）
  }

  // 打开自动拆分成功结果弹窗
  const handleOpenAutoSplitSuccess = (palletData: any[], userPalletStacking: number = 100) => {
    setSplitPalletData(palletData)
    setUserPalletStacking(userPalletStacking)  // 保存 userPalletStacking
    setAutoSplitSuccessVisible(true)
  }

  // 关闭自动拆分成功结果弹窗
  const handleCloseAutoSplitSuccess = () => {
    setAutoSplitSuccessVisible(false)
    setSplitPalletData([])
    setUserPalletStacking(100)  // 重置为默认值
    setSelectedSplitItem(null)
  }

  // 打开合并到托盘弹窗
  const handleOpenMergeToPallet = (selectedItems: any[]) => {
    setSelectedMergeItems(selectedItems)
    setMergeToPalletVisible(true)
  }

  // 关闭合并到托盘弹窗
  const handleCloseMergeToPallet = () => {
    setMergeToPalletVisible(false)
    setSelectedMergeItems([])
  }

  // 合并成功后的回调
  const handleMergeSuccess = (result: any) => {
    // 刷新 Putaway Board 数据
    setPutawayRefreshTrigger(Math.random())
    // 打开合并成功弹窗
    setMergePalletResult(result.palletResult)
    setMergeSuccessItems(result.mergedItems)
    setMergeSuccessVisible(true)
  }

  // 关闭合并成功弹窗
  const handleCloseMergeSuccess = () => {
    setMergeSuccessVisible(false)
    setMergePalletResult(null)
    setMergeSuccessItems([])
    // 刷新列表
    setTriggerResetData(Math.random())
  }


  const getBlob = (blob?:any) => {
    // console.log(blob, 'blob111')
    setEmailBlob(blob)
  }
  // useEffect(() => {
  //   if (pageType==2 ) document.title = "Purchase Order Approve";
  //   else if (pageType==1 ) document.title = "Purchase Order";
  //   else  document.title = "Payable";
  // }, [])
  useDocumentTitle();
  const purchaseOrderDialog = <PurchaseOrderDialog isNewOrder={isNewOrder} onDialogClose={onDialogClose} orderData={orderData} isView={isView}/>
  const setButton = () => {
    let buttons = [
      {
        icon:  <MailOutlined />,
        text: <MailOutlined />,
        color: '#4CAF50',
        className: 'jc-btn--green',
        iconOnly: true,
        title: 'Email PO',
        onClick: ( rowData: any) => {
          if (rowData.poStatusId == 1) {
            SweetAlertService.errorMessage('This order should be approved.')
            return
          }
          console.log(rowData)

          const personInEmail = {
            employeeEmail: getCookie('email'),
            customerEmail: rowData.suplier.email
          }
          // console.log(personInEmail)
          setRowData(personInEmail)
          const obj = {
            employeeEmail: getCookie('email'),
            // address: rowData.customer.address2 + ' ' + rowData.customer.address1,
            ...rowData
          }

          // PurchaseOrderPdf(obj)
          setPdfData(obj)
          PurchaseOrderPdf(obj, 'getBlob', getBlob)
          setIsEmailModalVisible(true)
        }
      },
      {
        icon: pageType==2 ? <EditOutlined /> : <EyeOutlined />,
        text: pageType==2?'Edit':'View',
        color: '#1976D2', // Primary Blue
        className: 'jc-btn--blue',
        title: pageType==2?'Edit Order':'View Order',
        onClick: ( rowData: any) => {
          setisView(pageType==2?false:true)
          setOpen(true)
          setOrderData(rowData)
          setDialogTitle(pageType==2?'Order Edit':'Order View')
          setIsNewOrder(false)
        }
      },
      {
        icon: <FileTextOutlined />,
        text: 'Notes',
        color: '#F44336',
        className: 'jc-btn--amber',
        title: 'Edit Notes',
        onClick: async (rowData: any) => {

          const result = await SweetAlertService.inputConfirm({ type: 'text', title: 'Input Note', placeholder: 'Notes', defaultValue: rowData.notes })
          if (result) {
            ApiRequest({
              url: 'PurchaseOrder/UpdateNotes?id=' + rowData.poId + '&notes=' + result,
              method: 'put'
            }).then(_ => {
              SweetAlertService.successMessage()
              setTriggerResetData(Math.random())
            })
          }
        }
      },
      {
        icon: <CheckOutlined />,
        text: 'Approve',
        color: '#673AB7',
        className: 'jc-btn--solid',
        title: 'Approve Order',
        onClick: async (rowData: any) => {
          if (rowData.poStatusId !== 1) {
            SweetAlertService.errorMessage('This order\'s status is not awaiting approved.')
            return
          }
          const result = await SweetAlertService.confirmMessage()
          if (result) {
            ApiRequest({
              url: 'PurchaseOrder/ApprovePurchaseOrder?id=' + rowData.poId,
              method: 'put'
            }).then(_ => {
              setTriggerResetData(Math.random())
            })
          }
        }
      },
      {
        icon: <CheckCircleOutlined />,
        text: 'Finish',
        color: '#757575',
        className: 'jc-btn--solid',
        title: 'Finish Order',
        onClick: async (rowData: any) => {
          // 第一级判断：检查是否是 Receiving 状态 (poStatusId=4)
          if (rowData.poStatusId != 4) {
            SweetAlertService.errorMessage('This PO cannot be finished because the order is not in receiving status.')
            return
          }

          // 第二级判断：检查 Rcv != Ord
          const hasMismatch = rowData.poDetail?.some((detail: any) => {
            const ord = detail.quantity || 0
            const rcv = detail.totalRevQty || 0
            return rcv !== ord
          })

          if (hasMismatch) {
            // 显示警告并给出按钮选择
            const result = await Swal.fire({
              title: 'P/W Qty Not Match',
              html: `
                <div style="text-align: left;">
                  <p>Final P/W Qty does not match Order Qty for some items.</p>
                  <div style="background: #fef3c7; padding: 12px; border-radius: 6px; margin: 10px 0;">
                    <div><strong>PO Number:</strong> ${rowData.poNo}</div>
                  </div>
                  <p style="color: #f59e0b;">Do you want to continue?</p>
                </div>
              `,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Continue',
              cancelButtonText: 'Cancel',
              confirmButtonColor: '#10b981',
              cancelButtonColor: '#6b7280'
            })

            if (result.isConfirmed) {
              // 用户选择 Continue，继续完成流程
              const confirmResult = await SweetAlertService.confirmMessage('Are you sure you want to finish this purchase order?')
              if (confirmResult) {
                ApiRequest({
                  url: 'PurchaseOrder/CompletePurchaseOrder?id=' + rowData.poId,
                  method: 'put'
                }).then(_ => {
                  setTriggerResetData(Math.random())
                })
              }
            }
            // 如果用户选择 Cancel，不做任何操作
          } else {
            // 没有不匹配，直接确认
            const result = await SweetAlertService.confirmMessage('Are you sure you want to finish this purchase order?')
            if (result) {
              ApiRequest({
                url: 'PurchaseOrder/CompletePurchaseOrder?id=' + rowData.poId,
                method: 'put'
              }).then(_ => {
                setTriggerResetData(Math.random())
              })
            }
          }
        }
      }
    ];

    // ✅ 添加 Log 按钮 (第一行第4个按钮)
    if (pageType === 2) {
      // 在 Notes 之后、Approve 之前插入 Log 按钮
      buttons.splice(3, 0, {
        icon: <FileTextOutlined />,
        text: 'Log',
        color: '#2196F3', // 蓝色
        className: 'jc-btn--slate',
        title: 'Inspection Log',
        onClick: async (rowData: any) => {
          handleOpenApproveLog(rowData)
        }
      })
    }

    // ✅ 添加 Delete 按钮 (第二行第3个按钮)
    if (pageType === 2) {
      buttons.push({
        icon: <DeleteOutlined />,
        text: <DeleteOutlined />,
        color: '#E91E63', // 粉红红色
        className: 'jc-btn--rose',
        iconOnly: true,
        title: 'Delete Order',
        onClick: async (rowData: any) => {
          if (rowData.poDetail && rowData.poDetail.length > 0) {
            SweetAlertService.errorMessage('Only the orders has no details can be deleted.')
            return
          }
          const result = await SweetAlertService.confirmMessage('Are you sure to delete this order?')
          if (result) {
            const res = await ApiRequest({
              url: 'PurchaseOrder/DeletePurchaseOrder?id=' + rowData.poId,
              method: 'delete'
            })
            if (res) {
              await SweetAlertService.successMessage('Order deleted successfully')
              setTriggerResetData(Math.random())
            }
          }
        }
      })
    }

    const newCol = {
      title: 'Actions',
      field: 'Buttons',
      editable: 'never',
      render: (rowData: any) => {
        // 条件按钮：Approve 仅 Pending 状态显示，Finish 仅 Receiving 状态显示
        const visibleButtons = buttons.filter((button) => {
          if (typeof button.text === 'string' && button.text === 'Approve') {
            return rowData.poStatusId === 1
          }
          if (typeof button.text === 'string' && button.text === 'Finish') {
            return rowData.poStatusId === 4
          }
          return true
        })

        // 3 列等宽网格：所有按钮上下左右严格对齐，行高随按钮数量自适应
        return (
          <div className="jc-po-actions">
            {visibleButtons.map((button: any) => (
              <button
                key={getRandomKey()}
                type="button"
                className={`jc-btn ${button.className || 'jc-btn--slate'}${button.iconOnly ? ' jc-btn--icon' : ''}`}
                title={button.title}
                onClick={() => button.onClick(rowData)}
              >
                {React.isValidElement(button.icon) && button.icon}
                {!button.iconOnly && typeof button.text === 'string' && button.text}
              </button>
            ))}
          </div>
        )
      },
    };
    return newCol;
  };
  const setPayableButton = () => {
    const newCol = {
      title: 'Payment',
      field: 'paymentStatus',
      editable: 'never',
      render: (rowData: any) => (
        <div>
          <button
            key={getRandomKey()}
            type="button"
            className="jc-btn jc-btn--solid jc-btn--block"
            title="Mark Paid / Unpaid"
            onClick={async () => {
              let result = await editInvoice(rowData);
              if (result.isConfirmed) {
                let paymentStatus = result.value?.paymentStatus === "Paid" ? 1 : 0;
                let paymentDate = result.value?.paymentDate;
                ApiRequest({
                  url: `PurchaseOrder/MarkPaid?id=${rowData.poId}&paymentStatus=${paymentStatus}&invoiceNumber=${result.value?.invoiceNumber}&paymentDate=${paymentDate}`,
                  method: 'put'
                }).then(_ => {
                  SweetAlertService.successMessage()
                  setTriggerResetData(Math.random())
                })
              }
            }}
          >
            <DollarOutlined /> Paid / Unpaid
          </button>
        </div>
      ),
    };
    return newCol;
  };

  const actionButtons: any = pageType === 4 ? [] : [
    {
        icon: '',
        tooltip: 'New Order',
        isFreeAction: true,
        onClick: (event: any, rowData: any) => {
          setisView(false);
          setOpen(true)
          setOrderData({})
          setDialogTitle('New Purchase Order')
          setIsNewOrder(true)
        }
      }
    ];

  const getRenderData = (data: any) => {
    const renderData: any = []
    data.map((row: any) => {
      renderData.push({
        ...row,
        supplierName: row.suplier?.suplierName,
        deliveryDate1: moment.utc(row.deliveryDate).local().format('DD/MM/YYYY'),
        dueDate1: moment.utc(row.dueDate).local().format('DD/MM/YYYY'),
        // toLocalDate(row.deliveryDate),
        createdEmployeeName: (row.createdEmployee?.firstName || '') + ' ' + (row.createdEmployee?.lastName || '')
      })
    })

    // 对 Purchase Order (pageType=1) 和 Purchase Order Approve (pageType=2) 应用排序
    if (pageType === 1 || pageType === 2) {
      renderData.sort((a: any, b: any) => {
        // 1. PO状态排序: Pending (1) > Receiving (4) > Approved (2)
        const statusOrder: any = { 1: 0, 4: 1, 2: 2 } // Pending 排第一，Receiving 排第二，Approved 排第三
        const aStatusOrder = statusOrder[a.poStatusId] ?? 99
        const bStatusOrder = statusOrder[b.poStatusId] ?? 99

        if (aStatusOrder !== bStatusOrder) {
          return aStatusOrder - bStatusOrder
        }

        // 2. PO No排序
        // 处理可能包含前缀的 PO No，提取数字部分进行比较
        const aPoNo = a.poNo?.toString().replace(/[^0-9]/g, '') || '0'
        const bPoNo = b.poNo?.toString().replace(/[^0-9]/g, '') || '0'
        // Purchase Order (pageType=1): PO No 升序 (从小到大)
        return parseInt(bPoNo) - parseInt(aPoNo)
      })
    }
    // 只对 Purchase Order Receiving (pageType=4) 应用特殊排序
    else if (pageType === 4) {
      renderData.sort((a: any, b: any) => {
        // 1. PO状态排序: Receiving (4) > Approved (2) > 其他
        const statusOrder: any = { 4: 0, 2: 1 } // Receiving 排第一，Approved 排第二
        const aStatusOrder = statusOrder[a.poStatusId] ?? 99
        const bStatusOrder = statusOrder[b.poStatusId] ?? 99

        if (aStatusOrder !== bStatusOrder) {
          return aStatusOrder - bStatusOrder
        }

        // 2. ETA排序: 从最近到最远 (升序)
        const aEta = a.deliveryDate ? new Date(a.deliveryDate).getTime() : Infinity
        const bEta = b.deliveryDate ? new Date(b.deliveryDate).getTime() : Infinity
        if (aEta !== bEta) {
          return aEta - bEta
        }

        // 3. PO No排序: 从小到大 (升序)
        // 处理可能包含前缀的 PO No，提取数字部分进行比较
        const aPoNo = a.poNo?.toString().replace(/[^0-9]/g, '') || '0'
        const bPoNo = b.poNo?.toString().replace(/[^0-9]/g, '') || '0'
        return parseInt(aPoNo) - parseInt(bPoNo)
      })
    }

    return renderData
  }
  const setCol = () =>{
    let ret = PurchaseOrderColumnModel(pageType, handleOpenReceivingModal, handleOpenPutawayModal, handleOpenInspectionLog);
    if (pageType==3)
      ret.push(setPayableButton())
    else if (pageType==4) {
      // 接收页面：不需要额外的按钮列，已经在column model中处理
      ret = ret.filter((col: { field: any }) => col.field !== 'payable');
    } else {
      ret.push(setButton())
      ret = ret.filter((col: { field: any }) => col.field !== 'payable');
    }
    return ret;
  }
  const editInvoice = async (row: any) =>{
    const currentDate = new Date().toISOString().split('T')[0]; // Get current date in "yyyy-mm-dd" format
    let dollarSignColorIndex = 0; // Index to cycle through colors
    const dollarSignColors = ['#e5bb4b', 'blue', 'red', 'green']; // Colors to cycle through for dollar sign
  
    const result = await Swal.fire({
      // iconHtml: '<i class="fas fa-file-invoice-dollar"></i>',
      title: `<b style="color: ${dollarSignColors[dollarSignColorIndex]};">$</b> Input Invoice Information`,
      // iconHtml: '<i class="fas fa-receipt"></i>',

      html: `
      <div class="swal-input-container">
        <label for="paymentDate" style="color: blue;">Date of Payment:</label>
        <input id="paymentDate" type="date" value="${currentDate}" required>
      </div>
        <div id="paymentStatus" class="swal-input-container" style="display: flex; align-items: center;">
          <input id="paymentStatusPaid" type="radio" name="paymentStatus" value="Paid"  style="margin-right: 2px;" required>
          <label for="paymentStatusPaid" style="color: red;margin-right: 2px">Paid</label>
          <input id="paymentStatusUnpaid" type="radio" name="paymentStatus" value="Unpaid"  style="margin-right: 2px;" checked required>
          <label for="paymentStatusUnpaid" style="color: green;margin-right: 2px">Unpaid</label>
        </div>
        <div class="swal-input-container">
          <label for="invoiceNumber" style="color: blue;">Invoice Number:</label>
          <input id="invoiceNumber" type="text" required>
        </div>
      `,
      onOpen: () => {
        console.log("pass row is:", row);
        if (row) {
          (document.getElementById("paymentDate") as HTMLInputElement).valueAsDate = row.paymentDate ? new Date(row.paymentDate) : new Date();
          (document.getElementById("invoiceNumber") as HTMLInputElement).value = row.invoiceNote;
          if (row.paid)
            (document.getElementById("paymentStatusPaid") as HTMLInputElement).checked  = true;
          else
            (document.getElementById("paymentStatusUnpaid") as HTMLInputElement).checked  = true;
        }
  
        // Disable invoice number input when "Unpaid" is selected
        // paymentStatus.addEventListener("change", () => {
        //   console.log(invoiceNum)
        //   invoiceNum.disabled = !paymentStatusPaid.checked;
        //   invoiceNum.value="";
        // });
  
        // Initially disable invoice number input if "Unpaid" is selected
        // invoiceNum.disabled = !paymentStatusPaid.checked;
       
      },     
      preConfirm: () => {
        // return new Promise((resolve, reject) => {
          const paymentDate = (document.getElementById('paymentDate') as HTMLInputElement)?.value;
          const paymentStatus = (document.querySelector('input[name="paymentStatus"]:checked') as HTMLInputElement)?.value;
          const invoiceNumber = (document.getElementById('invoiceNumber') as HTMLInputElement)?.value;
          return({ paymentDate, paymentStatus, invoiceNumber });
      },              
      showCancelButton: true,
      focusConfirm: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        container: 'custom-swal-container',
        confirmButton: 'custom-swal-confirm-button',
        cancelButton: 'custom-swal-cancel-button'
      }
    });
    console.log(result)
    return result;
  }
  const onChangeDateRange = (value: any) => {
    setStartDate(value ? value[0] : null)
    setEndDate(value ? value[1] : null)
    let newUrl = 'PurchaseOrder/GetAllPurchaseOrder'
    if (value && value.length === 2) {
      newUrl = `PurchaseOrder/GetAllPurchaseOrder?start=${value[0].format('YYYY/MM/DD')}&end=${value[1].format('YYYY/MM/DD')}`
    }
    setUrl(newUrl)
    setTriggerResetData(!triggerResetData)
  }

  const onClearDateRange = () => {
    setStartDate(moment().add(SIX_MONTHS_AGO, 'months'))
    setEndDate(moment())
    if (startDate && endDate) {
      setUrl(`PurchaseOrder/GetAllPurchaseOrder?start=${startDate.format('YYYY/MM/DD')}&end=${endDate.format('YYYY/MM/DD')}`);
    }
    // setUrl('PurchaseOrder/GetAllPurchaseOrder')
    setTriggerResetData(!triggerResetData)
  }

  const commonTablePageProps: CommonTablePagePropsInterface = {
    urlInfoKey: urlKey.PurchaseOrder,
    getAllUrl: url,
    title: pageType === 1 ? 'Purchase Order' :
           pageType === 2 ? 'Purchase Order Approve' :
           pageType === 3 ? 'Payable' :
           'Purchase Order Receiving',
    column: setCol(),
    mappingRenderData: (data: any) => getRenderData(data),
    toolbarExtra: (
      <>
        <span className="jc-extra-label">Date Range</span>
        <RangePicker
          value={[startDate, endDate]}
          onChange={onChangeDateRange}
          allowClear={false}
        />
        <Button onClick={onClearDateRange}>
          Clear Date
        </Button>
      </>
    ),
    actionButtons : pageType != 3 ? actionButtons : [],
    triggerResetData: triggerResetData,
    isNotDeletable: true,
    isNotEditable: true,
    isNotAddable: true,
    isShowSpinnerOnInit: isShowSpinner
  }

  const [isEmailModalVisible, setIsEmailModalVisible] = useState(false)
  const [rowData, setRowData] = useState<Email>()
  const [emailBlob, setEmailBlob] = useState()


  return (
    <div className={`purchase-order-page-${pageType}`}>
      <style>
      {`
        /* 明细列表紧凑化：缩小表体单元格的垂直内边距，行高随内容自适应 */
        .purchase-order-page-1 .MuiTableBody-root .MuiTableCell-root,
        .purchase-order-page-2 .MuiTableBody-root .MuiTableCell-root,
        .purchase-order-page-3 .MuiTableBody-root .MuiTableCell-root,
        .purchase-order-page-4 .MuiTableBody-root .MuiTableCell-root {
          padding: 2px 8px !important;
        }

        /* 隐藏所有purchase-order页面的Actions列 */
        .purchase-order-page-1 .MuiTableCell-root:last-child,
        .purchase-order-page-2 .MuiTableCell-root:last-child,
        .purchase-order-page-3 .MuiTableCell-root:last-child,
        .purchase-order-page-4 .MuiTableCell-root:last-child,
        .purchase-order-page-1 .MuiTableHead-root .MuiTableCell-root:last-child,
        .purchase-order-page-2 .MuiTableHead-root .MuiTableCell-root:last-child,
        .purchase-order-page-3 .MuiTableHead-root .MuiTableCell-root:last-child,
        .purchase-order-page-4 .MuiTableHead-root .MuiTableCell-root:last-child,
        .purchase-order-page-1 .MuiTableBody-root .MuiTableCell-root:last-child,
        .purchase-order-page-2 .MuiTableBody-root .MuiTableCell-root:last-child,
        .purchase-order-page-3 .MuiTableBody-root .MuiTableCell-root:last-child,
        .purchase-order-page-4 .MuiTableBody-root .MuiTableCell-root:last-child {
          display: none !important;
          width: 0 !important;
          padding: 0 !important;
          margin: 0 !important;
          border: none !important;
        }

        /* 倒数第二列sticky定位 - 表体 */
        .purchase-order-page-1 .MuiTableBody-root .MuiTableCell-root:nth-last-child(2),
        .purchase-order-page-2 .MuiTableBody-root .MuiTableCell-root:nth-last-child(2),
        .purchase-order-page-3 .MuiTableBody-root .MuiTableCell-root:nth-last-child(2),
        .purchase-order-page-4 .MuiTableBody-root .MuiTableCell-root:nth-last-child(2) {
          position: sticky !important;
          right: 20px;
          background: #fff;
          z-index: 1;
        }

        /* 倒数第二列sticky定位 - 表头，更高的z-index确保不被覆盖 */
        .purchase-order-page-1 .MuiTableHead-root .MuiTableCell-root:nth-last-child(2),
        .purchase-order-page-2 .MuiTableHead-root .MuiTableCell-root:nth-last-child(2),
        .purchase-order-page-3 .MuiTableHead-root .MuiTableCell-root:nth-last-child(2),
        .purchase-order-page-4 .MuiTableHead-root .MuiTableCell-root:nth-last-child(2) {
          position: sticky !important;
          right: 0 !important;
          background: #fff;
          z-index: 10 !important;
          padding-left: 16px !important;
        }
      `}
      </style>
      <CommonTablePageWithSortPreserve {...commonTablePageProps} />
      <CommonDialog title={dialogTitle} open={open} onDialogClose={onDialogClose} dialogContent={purchaseOrderDialog} />
      <EmailModal1 visible={isEmailModalVisible} onCancel={() => setIsEmailModalVisible(false)} rowData={rowData} blob={emailBlob} pdfData={pdfData} />
      <PurchaseOrderReceivingModal
        visible={receivingModalVisible}
        onClose={handleCloseReceivingModal}
        poData={selectedPOData}
        onSuccess={handleReceivingSuccess}
      />
      <PurchaseOrderPutawayModal
        visible={putawayModalVisible}
        onClose={handleClosePutawayModal}
        poData={selectedPOData}
        onSuccess={handlePutawaySuccess}
        onOpenAutoSplitModal={handleOpenAutoSplitModal}
        onOpenMergeToPalletModal={handleOpenMergeToPallet}
        refreshTrigger={putawayRefreshTrigger}
      />
      <AutoSplitPalletModal
        visible={autoSplitModalVisible}
        onClose={handleCloseAutoSplitModal}
        poData={selectedPOData}
        itemData={selectedSplitItem}
        onSuccess={handleSplitSuccess}
      />
      <AutoSplitSuccessModal
        visible={autoSplitSuccessVisible}
        onClose={handleCloseAutoSplitSuccess}
        poData={selectedPOData}
        itemData={selectedSplitItem}
        palletData={splitPalletData}
        userPalletStacking={userPalletStacking}
        onSuccess={() => {
          setTriggerResetData(Math.random())
          setPutawayRefreshTrigger(Math.random())
        }}
      />
      <MergeToPalletModal
        visible={mergeToPalletVisible}
        onClose={handleCloseMergeToPallet}
        poData={selectedPOData}
        selectedItems={selectedMergeItems}
        onSuccess={handleMergeSuccess}
      />
      <MergeSuccessModal
        visible={mergeSuccessVisible}
        onClose={handleCloseMergeSuccess}
        poData={selectedPOData}
        mergedItems={mergeSuccessItems}
        palletResult={mergePalletResult}
        onSuccess={() => {
          setTriggerResetData(Math.random())
          setPutawayRefreshTrigger(Math.random())
        }}
      />
      <InspectionLogModal
        visible={inspectionLogVisible}
        onClose={handleCloseInspectionLog}
        inspectionId={selectedInspectionPOData?.inspectionId || ''}
      />
    </div>
  )
}
